<template>
  <div
    v-if="Object.keys(allComponentList).length !== 0"
    ref="componentList"
    class="component-list-wrapper"
  >
    <div
      class="list-box"
      v-for="(item, key, idx) in allComponentList"
      :key="idx"
    >
      <div class="list-box_header">
        <span class="title">{{ $t("lcd.Editor.Component List") }}</span>
        <i
          class="el-icon-arrow-right"
          :class="[state.showComponentList == key && 'is-active']"
          @click="toggleVisible(key)"
        />
      </div>
      <el-collapse-transition>
        <div v-show="state.showComponentList == key">
          <div v-for="component in item" :key="component.componentId">
            <span
              :class="{ active: isActive(component) }"
              @click="clickComponentInList(component.index)"
              >{{ component.name }}</span
            >
            <i
              v-if="component.type != 'TumengAd'"
              class="el-icon-delete"
              @click="handleClickDeleteComponent(component, component.index)"
            />
            <tumeng-svg-icon
              v-show="component.hide === false"
              icon-class="invisible"
              class-name="invisible"
              @click="component.hide = true"
            />
            <tumeng-svg-icon
              v-show="component.hide === true"
              icon-class="visible"
              class-name="visible"
              @click="component.hide = false"
            />
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import { Drag } from "../../../utils/drag";

export default {
  name: "ComponentList",
  inject: ["getNewComponentId"],
  data() {
    return {
      state: store.state,
    };
  },
  computed: {
    allComponentList() {
      const componentList = {};
      this.state.currentPageComponentList.forEach((item, index) => {
        const obj = item;
        obj.groupId = item.groupId || 1;
        obj.index = index;
        if (item.groupId && componentList[item.groupId]) {
          componentList[item.groupId].push(item);
        } else {
          componentList[item.groupId] = [item];
        }
        return componentList;
      });
      this.state.programInfo.pages[this.state.currentPageIdx].groupNum =
        Object.keys(componentList).length;
      return componentList;
    },
    ownProgramData() {
      return this.state.programInfo;
    },
    containerStyle() {
      const scaleX = 143 / this.ownProgramData.width;
      const scaleY = 96 / this.ownProgramData.height;
      let top;
      let left;
      if (scaleX <= 1.0) {
        left = "-" + (this.ownProgramData.width / 2) * (1 - scaleX) + "px";
      } else {
        left = (this.ownProgramData.width / 2) * (scaleX - 1) + "px";
      }
      if (scaleY <= 1.0) {
        top = "-" + (this.ownProgramData.height / 2) * (1 - scaleY) + "px";
      } else {
        top = (this.ownProgramData.height / 2) * (scaleY - 1) + "px";
      }
      return {
        position: "absolute",
        width: this.ownProgramData.width + "px",
        height: this.ownProgramData.height + "px",
        background: "#fff",
        transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
        left,
        top,
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.$refs.componentList) {
        return setTimeout(this.init, 1);
      }
      const that = this;
      new Drag(this.$refs.componentList, function (left, top) {
        if (left < 0) {
          left = 0;
        }
        if (top < 0) {
          top = 0;
        }
        that.$refs.componentList.style.left = left + "px";
        that.$refs.componentList.style.top = top + "px";
      });
    },
    isActive(component) {
      const list = store.state.multipleComponentList;
      if (list.length && list.indexOf(component.componentId) !== -1) {
        return true;
      }
      if (
        store.state.activeComponent &&
        store.state.activeComponent.componentId === component.componentId
      ) {
        return true;
      } else {
        return false;
      }
    },
    clickComponentInList(index) {
      if (store.state.isCtrl) {
        store.addComponentForMultiple(index);
        return;
      }
      if (store.state.multipleComponentList.length) {
        store.state.multipleComponentList = [];
      }
      store.updateActiveComponentIdx(index);
    },
    handleClickDeleteComponent(component, index) {
      this.$emit("delete-component", {
        component,
        index,
      });
    },
    toggleVisible(key) {
      // store.updateShowComponentList(!store.state.showComponentList)
      store.updateShowComponentList(key);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/style/clearfix";
.component-list-wrapper {
  position: absolute;
  background: #0e1113;
  color: #fff;
  font-size: 14px;
  font-family: "AlibabaPuHuiTi-3-55-Regular", serif;
  padding: 6px 8px;
  z-index: 10;
  width: 100px;
  top: 83px;
  left: 255px;
  white-space: nowrap;
  max-height: 500px;
  overflow-y: auto;
  box-sizing: content-box;
  .list-box {
    &_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ffffff;
      .title {
        display: flex;
        align-items: center;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
      }
      .el-icon-arrow-right {
        transition: transform 0.3s;
        &.is-active {
          transform: rotate(90deg);
        }
      }
    }
    > div {
      user-select: none;
      overflow: hidden;
      &:first-of-type {
        cursor: move;
        transition: 0.3s color;
        &:hover {
          color: #f66;
        }
        .el-icon-arrow-down {
          cursor: pointer;
          float: right;
        }
      }
      /*包裹每一个组件的那个div*/
      > div {
        @include clearfix;
        margin: 4px 0;
        cursor: pointer;
        transition: 0.3s color;
        > span,
        > i {
          float: left;
          height: 20px;
          line-height: 20px;
          vertical-align: middle;
        }
        > span {
          width: 62px;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            color: orange;
          }
          &.active {
            color: greenyellow;
          }
        }
        i {
          width: 14px;
          margin-right: 8px;
          &:hover {
            color: red;
          }
        }
        .visible,
        .invisible {
          line-height: 20px;
          vertical-align: middle;
          font-size: 16px;
          color: #fff;
          &:hover {
            color: #ccc;
          }
        }
      }
    }
  }
}
</style>
